import React, { createContext, useContext, ReactNode, useEffect, useState } from 'react';

interface MobileContextProps {
  isMobile: boolean;
  isLandscape: boolean;
}

const MobileContext = createContext<MobileContextProps | undefined>(undefined);

export const MobileProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isMobile, setIsMobile] = React.useState(false);
  const [isLandscape, setIsLandscape] = useState(
    typeof window !== 'undefined' && window.innerWidth > window.innerHeight
  );

  useEffect(() => {
    const userAgent = navigator?.userAgent;

    const handleResize = () => {
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;

      setIsMobile(/Android|iPhone|iPad|Tablet/i.test(userAgent) || windowWidth <= 800);
      setIsLandscape(windowWidth > windowHeight);
    };

    // Initial setup
    handleResize();

    // Add event listeners
    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, []);

  return <MobileContext.Provider value={{ isMobile, isLandscape }}>{children}</MobileContext.Provider>;
};

export const useMobile = (): MobileContextProps => {
  const mobile = useContext(MobileContext);
  if (!mobile) {
    return { isMobile: false, isLandscape: false };
  }
  return mobile;
};
